import { IAllocationDimensionColumns, IDoorGroup } from "helpers/door-collection";

export interface IDimensionElementValue {
    id: string;
    key: string;
    text: string;
}
export interface IDimensionElement {
    id: string;
    name: string;
    selectionType: DimensionSelectionType;
    values: IDimensionElementValue[];
    isUserDefined?: boolean;
    collectionName?: string;
    top?: number;
}

export enum DimensionCheckBoxState {
    On,
    Disabled,
    Hidden,
}

export enum DimensionSelectionType {
    DoorGroup = "doorGroup",
    DoorGroupDirection = "doorGroupDirection",
    AllocationDimensions = "allocationDimensions",
    DoorGroupingLabel = "doorGroupingLabel",
}

export type DimensionPanelStore = {
    showDoors: boolean;
    [DimensionSelectionType.DoorGroup]: IDoorGroup[] | undefined;
    [DimensionSelectionType.AllocationDimensions]: IAllocationDimensionColumns | undefined;
};

export enum DimensionTab {
    Doors = 0,
    Attributes = 1,
    Metrics = 2,
}

export enum DimentionActionCommands {
    EditDoorGrouping = "EditDoorGrouping",
    RenameDoorGrouping = "RenameDoorGrouping",
    DeleteDoorGrouping = "DeleteDoorGrouping",
    DoorsLabelGrouping = "DoorsLabelGrouping",
    AddGrouping = "AddGrouping",
    AscSorting = "AscSorting",
    DescSorting = "DescSorting",
    ImportDoorGroupings = "ImportDoorGroupings",
}
